import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { manitowocConfig } from "./data";

export default function ManitowocPage() {
  return <CityPageTemplate config={manitowocConfig} />;
}